import { render } from "./bruteVideo.vue?vue&type=template&id=b6fbdc34"
import script from "./bruteVideo.vue?vue&type=script&lang=js"
export * from "./bruteVideo.vue?vue&type=script&lang=js"

import "./bruteVideo.vue?vue&type=style&index=0&id=b6fbdc34&lang=css"

import exportComponent from "/Users/bob/Documents/GitHub/cdsa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__